var USER_ID = 'user_HW01im2YM0PtMfWsCfQlL';
var SERVICE_ID = 'service_6t7s72i';
var FORM_TEMPLATE_ID = 'template_3h58xcn';

export {USER_ID, SERVICE_ID, FORM_TEMPLATE_ID}